import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { GREY1 } from 'constants/colors';
import { getReferredApplicationNum } from 'apis/applications';


const useStyles = makeStyles((theme) =>
  createStyles({
    Wrapper: {
        width: 544,
        height: 344,
        display: 'grid',
        gridTemplateRows: '1fr auto',
        justifyItems: 'center',
        alignItems: 'center',
        textAlign: 'center',
        [theme.breakpoints.down(1280)]: {
            width: "100%",
            maxWidth: 400,
            height: "auto",
            gridTemplateRows: 'auto auto',
            gap: theme.spacing(2),
        },
    },
    Number: {
        fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
        fontWeight: 700,
        fontSize: 96,
        lineHeight: '125%',
        letterSpacing:0,
        color:GREY1,
        [theme.breakpoints.down(1280)]: {
            fontSize: 64,
        },
    },
    Caption: {
        fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
        fontWeight: 500,
        fontSize: 24,
        lineHeight: '125%',
        letterSpacing:0,
        color: GREY1,
        [theme.breakpoints.down(1280)]: {
            fontSize: 20,
        },
    }

  })
);

function formatCount(count: number | null): string {
  if (count === null) return ''; 
  if (count < 100) return count.toString();

  const bucket = Math.floor(count / 100) * 100;
  return `${bucket.toLocaleString()}+`;
}


export const ShowcaseNumber: React.FC = () => {
    const classes = useStyles();
    const [referredCount, setReferredCount] = useState<number | null>(null);

    useEffect(() => {
        const fetchCount = async () => {
        try {
            const referredCount = await getReferredApplicationNum();
            setReferredCount(Number(referredCount));
        } catch (error) {
            setReferredCount(null);
        }
        };

        fetchCount();
    }, []);
    const displayCount = formatCount(referredCount);
    
  
    return (
        <Box className={classes.Wrapper}>
            <Typography className={classes.Number}>
                {displayCount}
            </Typography>
            <Typography variant='h3'>
                NEX Work 已送出的內推人數
            </Typography>
        </Box>
    )
}